import { defineAction } from '~/prix'
import pointOfInterestFetchAction from './pointOfInterestFetch.action.json' assert { type: 'json' }
import { pointOfInterestObject } from '../pointOfInterestObject'
import { z } from 'zod'

const pointOfInterestFetchDefinition = defineAction({
  ...pointOfInterestFetchAction,

  input: z.object({
    id: z.string().uuid(),
  }),
  output: pointOfInterestObject,
})

export default pointOfInterestFetchDefinition
